import React, { useState, useEffect, useContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { makeStyles } from '@material-ui/core/styles';
import NumberField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Progressbar from '@material-ui/core/LinearProgress';
import axios from '../../../../../api/axios';
import { store } from '../../../../../store';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 500,
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > div:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const WaybillsParams = () => {
  useTitle('پارامترهای کرایه حمل')
  const classes = useStyles();
  const { showMessage, showError } = useContext(store);
  const [params, setParams] = useState({});
  const { baserate } = params;
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!baserate) {
      er.baserate = 'نرخ پایه را وارد نمائید. (تومان)';
    }

    // Validation patterns end here.

    if (isSingleValidation) {
      let err = {};

      for (const v in params) {
        if (params[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        setErrors(err);
        return false;
      }
      {
        setErrors({});
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        setErrors(er);
        return false;
      }
      setErrors(er);
      return true;
    }
  };
  const handleChage = (e) => {
    const { name, value } = e.target;
    setParams((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async () => {
    if (!validation()) return;
    try {
      axios.put(`/api/v1/admin/settings`, {
        settings: params,
        section: 'waybills',
      });
      showMessage('تنظیمات با موفقیت ذخیره گردید.');
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`/api/v1/admin/settings/waybills`);
        if (data && data.settings) {
          setParams(data.settings);
        }
        setLoading(false);
      } catch (error) {
        showError(error);
      }
    })();
  }, []);

  return (
    <FullCard
      title="پارامترهای کرایه‌حمل"
      category="تنظیم پارامترهای موثر در محاسبه کرایه حمل"
    >
      {loading ? (
        <Progressbar />
      ) : (
        <div className={classes.root}>
          <NumberField
            fullWidth
            variant="outlined"
            type="number"
            label="نرخ پایه کرایه / کیلومتر|تومان"
            name="baserate"
            onChange={handleChage}
            error={errors.baserate ? true : false}
            helperText={errors.baserate ? errors.baserate : ''}
            value={baserate ? baserate : ''}
            onBlur={validation}
          />
          <div>
            <Button
              variant="contained"
              fullWidth
              color="secondary"
              size="large"
              onClick={handleSubmit}
            >
              ذخیره
            </Button>
          </div>
        </div>
      )}
    </FullCard>
  );
};

export default React.memo(WaybillsParams);
